// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b7e259cf","548":"84278d68"}[chunkId] + ".chunk.js";
};